import React from 'react';

interface RadioButtonProps {
  checked: boolean;
  onChange: () => void;
  label: React.ReactNode;
  name: string;
  value: string | number;
  disabled?: boolean;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  checked,
  onChange,
  label,
  name,
  value,
  disabled,
}) => (
  <label className={`flex items-center cursor-pointer space-x-2 ${disabled ? 'opacity-50' : ''}`}>
    <span className={`relative flex items-center`}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className="sr-only"
        disabled={disabled}
      />
      <span
        className={`w-5 h-5 rounded-full flex items-center justify-center transition-colors
          ${checked ? 'border-2 border-primary  bg-primary' : 'bg-[#E1E9F0]'}
          `}
      >
        {checked && <span className="w-2.5 h-2.5 rounded-full bg-white block" />}
      </span>
    </span>
    <span className="text-secondary font-ambit text-[0.9375rem] not-italic font-normal leading-[1.25rem]">
      {label}
    </span>
  </label>
);
